import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getPublicationsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
    publications: [
    {
        fieldName: "Order Sequence",
        fieldValue: "sequence",
        className: "col-span-6",
        type: "text",
        name: "sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_publication_image",
      className: "col-span-6",
      type: "image",
      name: "field_publication_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: " Title",
      validation: { required: " Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_publication_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_publication_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: " Title",
        // validation: { required: " Title is required" },
      },  {
        fieldName: "Title (ZH)",
        fieldValue: "field_publication_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_publication_title_zh",
        formType: "input",
        label: "Title (ZH)",
        placeholder: " Title",
        // validation: { required: " Title is required" },
      },
    // {
    //     fieldName: "Description (EN)",
    //     fieldValue: "field_publication_desc_en",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_publication_desc_en",
    //     formType: "richText",
    //     label: "Description (EN)",
    //     placeholder: "Enter Description (EN)",
    //     // validation: { required: "Description (EN) is required" },
    //   },
    //   {
    //     fieldName: "Description (MS)",
    //     fieldValue: "field_publication_desc_ms",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_publication_desc_ms",
    //     formType: "richText",
    //     label: "Description (MS)",
    //     placeholder: "Enter Description (MS)",
    //     // validation: { required: "Description (MS) is required" },
    //   },
    //   {
    //     fieldName: "Description (ZH)",
    //     fieldValue: "field_publication_desc_zh",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_publication_desc_zh",
    //     formType: "richText",
    //     label: "Description (ZH)",
    //     placeholder: "Enter Description (ZH)",
    //     // validation: { required: "Description (ZH) is required" },
    //   },
    {
      fieldName: "Publication url (EN)",
      fieldValue: "field_publication_redirect_url",
      className: "col-span-6",
      type: "pdf",
      name: "field_publication_redirect_url",
      formType: "file",
      usedFileType: ".pdf",
      label: "Publication url (EN)",
      placeholder: "Enter Publication url (EN)",
      validation: { required: "Publication URL (EN) is required" },
    },
    {
      fieldName: "Publication url (MS)",
      fieldValue: "field_publication_redirect_ms",
      className: "col-span-6",
      type: "pdf",
      name: "field_publication_redirect_ms",
      formType: "file",
      usedFileType: ".pdf",
      label: "Publication url (MS)",
      placeholder: "Enter Publication url (MS)",
      // validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Publication url (ZH)",
      fieldValue: "field_publication_redirect_zh",
      className: "col-span-6",
      type: "pdf",
      name: "field_publication_redirect_zh",
      formType: "file",
      usedFileType: ".pdf",
      label: "Publication url (ZH)",
      placeholder: "Enter Publication url (ZH)",
      // validation: { required: "Banner url (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "status",
      className: "col-span-12",
      type: "checkbox",
      name: "status",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
};
